// extracted by mini-css-extract-plugin
export default {"wrapper":"feed_wrapper__BStK2","title":"feed_title__O1qiz"};